(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('recaptcha', ["path", "recaptcha", function (path, recaptcha) {
        return {
            restrict: 'A',
            replace: false,
            scope: true,
            link: function ($scope, element, attrs) {
                var id = null;
                var loaded = false;
                recaptcha.init().then(function () {
                    loaded = true;
                    id = recaptcha.render(element[0]);
                });
                $scope.$on('$destroy', function () {
                    recaptcha.destroyed(id);
                });
            }
        };
    }]);
}());